"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("@emotion/react");
var makeListLayoutStyling = function (columns) {
    return {
        container: (0, react_1.css)({
            '&.MuiGrid-container.MuiGrid-spacing-xs-1': {
                width: '100%',
                margin: '-4px auto',
                maxWidth: 668,
            },
        }),
        item: (0, react_1.css)({
            '&.MuiGrid-item': __assign({ padding: '0 0 12px 0' }, (columns > 1 && {
                '@media (min-width: 330px)': {
                    paddingLeft: 3,
                    paddingRight: 3,
                },
                '@media (min-width: 430px)': {
                    paddingLeft: 6,
                    paddingRight: 6,
                },
            })),
        }),
    };
};
exports.default = makeListLayoutStyling;
//# sourceMappingURL=makeListLayoutStyling.js.map